export default "__VITE_ASSET__BgiV0hm7__"